<div class="pagination d-inline-flex align-items-center">
  <button [class.disabled]="startRow <= 0" (click)="changePage('prev')" class="prev d-flex"><i class="im-icon im-icon-chev-left"></i></button>
  <!-- start pages -->
  <button (click)="changePage(1)" [class.active]="currentPage === 1">{{pages[0]}}</button>
  @if (showFill(true)) {
    <span class="fill">...</span>
  }
  @for (i of pages; track i) {
    @if (i != 1 && i != pages.length && truncate(i)) {
      <button (click)="changePage(i)" [class.active]="currentPage === i">{{i}}</button>
    }
  }
  @if (showFill(false)) {
    <span class="fill">...</span>
  }
  @if (pages.length > 1) {
    <button (click)="changePage(pages.length)" [class.active]="currentPage === pages.length">{{pages[pages.length - 1]}}</button>
  }
  <!-- end pages -->
  <button [class.disabled]="startRow >= totalRows - RPP" (click)="changePage('next')" class="next d-flex"><i class="im-icon im-icon-chev-right"></i></button>
</div>